import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { backofficeUrl, T } from 'src/shared/helpers';
import usePermissions from 'src/shared/hooks/usePermissions';
import { AiOutlineButton } from '../ai';
import { AgentAddonActionCard } from './AgentAddonActionCard';
import { AgentRequirementControls } from './AgentRequirementControls';
import { useAgentAssistant } from './AgentAssistantContext';

export const AgentAccountRequirementCard: FC<{ action: string; busy: boolean; hasDraft?: boolean; onResume: () => void | Promise<void> }> = ({
    action,
    busy,
    onResume,
    hasDraft = false
}) => {
    const navigate = useNavigate();
    const { close } = useAgentAssistant();
    const { isAllowed } = usePermissions();
    if (action === 'free_credits_used_up')
        return <AgentAddonActionCard addonKey='AI_ACCOUNT' action={action} busy={busy} onResume={onResume} hasDraft={hasDraft} />;
    if (action !== 'manage_subscription') return null;
    const canManage = isAllowed(['SUBSCRIPTION']);
    return (
        <AgentRequirementControls disabled={busy}>
            <span>
                {canManage
                    ? T._('Your subscription is not active. Review your subscription to use the AI tools.', 'Admin')
                    : T._('Ask the account owner or a user with subscription permissions to review the subscription.', 'Admin')}
            </span>
            {canManage && (
                <AiOutlineButton
                    type='button'
                    $size='small'
                    disabled={busy}
                    onClick={() => {
                        close();
                        navigate(backofficeUrl('/seller/subscription'));
                    }}
                >
                    {T._('Manage subscription', 'Admin')}
                </AiOutlineButton>
            )}
            <AiOutlineButton type='button' $size='small' disabled={busy} onClick={() => void onResume()}>
                {T._('Check again', 'Admin')}
            </AiOutlineButton>
        </AgentRequirementControls>
    );
};
